import axios from "axios";
import initializeAxios from "../util/Axios";

class URLRedirects {
  constructor() {
    initializeAxios();
  }

  async createURLRedirect(data) {
    const response = await axios.post("/api/add-url-redirect", data);
    return response;
  }

  async getURLs() {
    const response = await axios.get("/api/get-redirected-urls");
    return response;
  }

  async updateURL(data) {
    const response = await axios.put("/api/update-url", data);
    return response.data;
  }

  async deleteUrl(id) {
    const response = await axios.delete("/api/delete-url/" + id);
    return response.data
  }
}

export default new URLRedirects();
